<template>
  <draggable
    v-model="itemList"
    :disabled="false"
    :animation="0"
    draggable=".action-draggable"
    :ghostClass="'suggestion-sortable-ghost' /* Class name for the drop placeholder */"
    :chosenClass="'sortable-chosen' /* Class name for the chosen item */"
    :dragClass="'sortable-drag' /* Class name for the dragging item */"
    :sort="false /* To disable sorting: set sort to false */"
    :emptyInsertThreshold="50"
    :group="{
      name: 'sessions',
      pull: 'clone',
      put: false, // Do not allow items to be put into this list
    }"
    @end="onDragEnd"
    @start="onDragStart"
    :move="onDragMove"
    :clone="cloneItem">
    <slot></slot>
  </draggable>
</template>

<script>
import Draggable from "vuedraggable";
import SidebarMixin from "@/components/TodayPage/Elements/SidebarMixin"
import SessionManagementMixin from "@/components/Mixins/SessionManagement"
//import clonedeep from "lodash.clonedeep";

export default {
  mixins: [ SidebarMixin, SessionManagementMixin ],
  props: {
    itemList: { required: true },
    clone: { type: Function },
  },
  methods: {
    cloneItem(item) {
      return this.clone(item)
    },
    onDragEnd(evt) {
      this.$emit("drag-end", evt); // TODO: Vuex
    },
    onDragStart(evt) {
      //this.$emit("first-move", evt); // TODO: Vuex
    },
    onDragMove($event) {
      this.onNewItemDragMove($event)
      this.$emit("first-move", $event); // TODO: Vuex
    }
  },
  components: {
    Draggable,
  }
};
</script>
